"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.savesearchDialog = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var classnames_1 = require("classnames");
var SaveSearchDialogAction_1 = require("@/pages/search/actions/sfilter/SaveSearchDialogAction");
var filterToKeyValueRow_1 = require("@/transformers/filterToKeyValueRow");
var GoogleMap_1 = require("@/api/vendor/GoogleMap");
var mapStateToProps = function (state) { return (__assign(__assign({}, state.savesearch), { googleApi: state.layout.googleApi, lang: state.layout.language.languages.find(function (it) { return it.id === state.layout.language.current; }).code1, currency: state.layout.currencies.options.find(function (it) { return it.key === state.layout.currencies.currentCurrencyId; }).key })); };
var mapDispatchToProps = function (dispatch) { return ({
    onCustomNameChanged: function (text) { return dispatch(SaveSearchDialogAction_1.default.onCustomNameChanged(text)); },
    onSaveSearchCloseClick: function () { return dispatch(SaveSearchDialogAction_1.default.onSaveSearchCloseClick()); },
    onSaveSearchSaveClick: function (name) {
        return dispatch(SaveSearchDialogAction_1.default.onSaveSearchSaveClick(name));
    },
    onSaveSearchSaveNewClick: function (name) {
        return dispatch(SaveSearchDialogAction_1.default.onSaveSearchSaveNewClick(name));
    },
}); };
exports.savesearchDialog = function (props) {
    var renderBody = function (props) {
        var renderRow = function (row, index) {
            return (React.createElement("div", { className: "c-pcard__row", key: index },
                React.createElement("div", { className: "c-pcard__row-label" }, row.key),
                React.createElement("div", { className: "c-pcard__row-value" }, row.value)));
        };
        return filterToKeyValueRow_1.filterToKeyValueRow(props.currentFilter, props.lang, props.currency, props.t)
            .map(function (row, index) {
            return renderRow(row, index);
        });
    };
    var classes = classnames_1.default([
        'l-fullscreen-dim',
        'l-fullscreen-dim--center',
        {
            'l-fullscreen-dim--active': props.isDim,
        },
        {
            'c-dialog--active': props.isActive,
        },
    ]);
    var districts = props.currentFilter.districts.filter(function (it) { return it.selected && it.area !== null; });
    var src = GoogleMap_1.getStaticImage(districts.length ? districts[0] : null, props.googleApi);
    var onCustomNameChanged = function (event) {
        props.onCustomNameChanged(event.currentTarget.value);
    };
    var onSearchPanelClick = function (event) {
        if (event.currentTarget !== event.target)
            return;
        props.onSaveSearchCloseClick();
    };
    var onSaveSearchSaveClick = function () {
        props.onSaveSearchSaveClick(props.customName);
    };
    var onSaveSearchSaveNewClick = function () {
        props.onSaveSearchSaveNewClick(props.customName);
    };
    var saveSearchClass = classnames_1.default([
        'o-btn',
        'o-btn--primary',
        {
            'o-btn--loading': props.isLoading,
        },
    ]);
    var savenewSearchClass = classnames_1.default([
        'o-btn',
        {
            'o-btn--loading': props.isLoading,
        },
    ]);
    var renderUpdate = function (props) { return (React.createElement("button", { id: "savesearch-save-button", onClick: onSaveSearchSaveClick, className: saveSearchClass },
        React.createElement("span", { className: "fas fa-save" }),
        " ",
        props.currentSearchId > 0 ? props.t.update : props.t.save)); };
    var renderSaveNew = function (props) {
        if (props.currentSearchId > 0 && props.saveNewEnabled) {
            return (React.createElement("button", { id: "savesearch-savenew-button", onClick: onSaveSearchSaveNewClick, className: savenewSearchClass },
                React.createElement("span", { className: "fas fa-plus-circle" }),
                " ",
                props.t.saveNew));
        }
    };
    var nameFieldClass = classnames_1.default([
        'c-form__input-subgroup',
        'c-form__field',
        {
            'c-form__field--disabled': props.isLoading,
        },
    ]);
    var renderError = function (message) { return (React.createElement("div", { style: { marginBottom: 0 }, className: "c-form__errors" }, message)); };
    return (React.createElement("div", { id: "savesearch-panel", className: classes, onMouseDown: onSearchPanelClick },
        React.createElement("div", { className: "c-dialog__main" },
            React.createElement("a", { id: "savesearch-close-button", className: "c-dialog__close js-close", onClick: props.onSaveSearchCloseClick },
                React.createElement("span", { className: "fal fa-times" })),
            React.createElement("div", { className: "c-dialog__title" }, props.t.title),
            React.createElement("div", { className: "c-dialog__body" },
                props.error ? renderError(props.error) : '',
                React.createElement("div", { className: "c-pcard" },
                    React.createElement("div", { className: "c-pcard__pic" },
                        React.createElement("img", { className: "c-pcard__img", src: src })),
                    React.createElement("div", { className: "c-pcard__info" },
                        React.createElement("div", { className: "c-pcard__head" },
                            React.createElement("div", { className: "c-pcard__title-editable" },
                                React.createElement("div", { className: "c-form__row" },
                                    React.createElement("div", { className: "c-form__input-group" },
                                        React.createElement("div", { className: nameFieldClass },
                                            React.createElement("input", { id: "savesearch-input", className: "c-form__subfield", placeholder: props.t.defaultName, value: props.customName, onChange: onCustomNameChanged, maxLength: 100, disabled: props.isLoading })),
                                        React.createElement("div", { className: "c-form__input-subgroup c-form__addon" },
                                            React.createElement("i", { className: "fal fa-edit" })))))),
                        React.createElement("div", { className: "c-pcard__body" }, renderBody(props)),
                        React.createElement("div", { className: "c-pcard__foot" },
                            React.createElement("div", { className: "c-pcard__actions" },
                                renderSaveNew(props),
                                renderUpdate(props),
                                React.createElement("a", { id: "savesearch-cancel-button", onClick: props.onSaveSearchCloseClick, className: "o-textbtn" }, props.t.cancel)))))))));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(exports.savesearchDialog);
